import Cookies from 'js-cookie';

export function isUserLoggedIn(): boolean {
  const profilesCookie = Cookies.get('_profiles_user');
  return profilesCookie && profilesCookie !== 'none';
}
